import { NumericType, TimeType } from "../../../../../shared/models/metric";
import { TimeInterval } from "../../../../../shared/models/module-manager/module-manager-settings.models";

export enum KPITrendModuleDisplay {
    Compact = "compact",
    Detailed = "detailed",
}
export interface IntervalSetting {
    intervalType: TimeInterval;
    intervalAmt: number;
}
export interface CxoneKPITrendModuleData {
    Error: ErrorCode;
    KpiTrendData: CxoneKPITrendWidgetComponentItem[];
}
export interface CxoneKPITrendWidgetComponentItem {
    MetricId: number;
    MetricName: string;
    Value?: any;
    NumericType?: NumericType;
    TimeType?: TimeType;
    DisplayValue?: string;
    UnitLabel?: string;
    SubLabel?: string;
    Trend?: CxoneKPIWidgetTrend;
    PrevValue?: any;
    PreviousValue?: string;
    PreviousLabel?: string;
    ChartData: { [key: string]: string };
}

export interface CxoneKPIWidgetTrend {
    Value: any;
    DisplayValue: string;
    ShowDirection: boolean;
    Difference: number;
    Color: string;
}

export enum ErrorCode {
    NoError = 0,
    NoMetric = 1,
    DateRangeToWideIntraDay = 2,
}
